/* =============================================================================
   CART (NEW) — adapter, not an engine
   -----------------------------------------------------------------------------
   The cart page runs Dawn's assets/cart.js: <cart-items> owns the debounced
   change listener, the POST to /cart/change.js, the Section Rendering API
   re-render, the live regions and the inline inventory errors. This file adds
   exactly two things:

   1. An INSTANCE-level getSectionsToRender() override on this page's
      <cart-items>. Dawn's default asks for four sections, one of which is
      `main-cart-footer` — a section this rebuild folded into cart-new, so the
      default would throw on `document.getElementById('main-cart-footer')
      .dataset.id`. The override is set on the element instance, shadowing the
      prototype method, so CartItems.prototype is untouched and the cart
      drawer's CartDrawerItems subclass keeps its own behaviour.

      Items, summary and sticky bar all live inside the one .js-contents, so a
      single entry re-renders all three. cart-icon-bubble stays in the list —
      that is the header bag count, and it is the same mechanism the header
      already documents itself as listening to.

   2. The sticky bar's measured height, published as --cart-sticky-height so
      the page can reserve exactly that much bottom padding. Re-measured after
      every cart update, because the bar is inside .js-contents and is
      therefore replaced by each re-render.
   ============================================================================= */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('main-cart-items');
    if (!root) return;
    var sectionId = root.dataset.id;

    /* ---- 1. Section list ------------------------------------------------ */
    var cartItems = root.querySelector('cart-items');
    if (cartItems) {
      cartItems.getSectionsToRender = function () {
        return [
          { id: 'main-cart-items', section: sectionId, selector: '.js-contents' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
        ];
      };

      /* Dawn's onCartUpdate fetches ?section_id=main-cart-items and reads a
         <cart-items> out of it. That section no longer exists; point it at
         this one. Fires when something else on the page changes the cart. */
      cartItems.onCartUpdate = function () {
        return fetch(window.Shopify.routes.root + '?section_id=' + encodeURIComponent(sectionId))
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var source = html.querySelector('.js-contents');
            var target = root.querySelector('.js-contents');
            if (source && target) {
              target.innerHTML = source.innerHTML;
              measureSticky();
            }
          })
          .catch(function (e) { console.error('[cart-new]', e); });
      };
    }

    /* ---- 2. Sticky bar height ------------------------------------------- */
    function measureSticky() {
      var bar = root.querySelector('[data-cart-sticky]');
      if (!bar) {
        root.style.removeProperty('--cart-sticky-height');
        return;
      }
      /* Only reserve space while the bar is actually laid out (it is
         display:none above 992px). */
      var h = bar.offsetHeight;
      if (h > 0) root.style.setProperty('--cart-sticky-height', h + 'px');
      else root.style.removeProperty('--cart-sticky-height');
    }

    measureSticky();
    window.addEventListener('resize', measureSticky, { passive: true });

    /* The bar lives inside .js-contents, so every cart update replaces it.
       Prefer the theme's own pub/sub; fall back to observing the container. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, measureSticky);
    } else {
      var contents = root.querySelector('.js-contents');
      if (contents && 'MutationObserver' in window) {
        new MutationObserver(measureSticky).observe(contents, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
